import { ActionTree } from 'vuex';
import { AxiosResponse } from 'axios';
import { IVerificationState } from './verification.types';
import { sendInviteToUser } from '@/modules/login/services/access-service';

const verificationActions: ActionTree<IVerificationState, any> = {
  inviteUser({ rootState }, sendEmail: boolean): Promise<AxiosResponse> {
    return sendInviteToUser(
      rootState.loginModule.metaInfo.userId,
      sendEmail,
      rootState.loginModule.organization?.name,
    )
      // @ts-ignore
      .then((response: AxiosResponse<any>) => response)
      .catch((response: AxiosResponse<any>) => {
        throw response;
      });
  },

  setSykValue({ commit }, sykValue: string): void {
    commit('setSykValue', sykValue);
  },

  resetSykValue({ commit }): void {
    commit('setSykValue', '');
  },

  setNetworkError({ commit }, error: string): void {
    commit('setNetworkError', error);
  },

  resetNetworkError({ commit }): void {
    commit('setNetworkError', undefined);
  },
};

export default verificationActions;
